'use client';

import { useEffect } from 'react';
import ClientCalendly from './ClientCalendly';

declare global {
  interface Window {
    Calendly: {
      initBadgeWidget: (options: {
        url: string;
        color: string;
        textColor: string;
        openUrl?: 'new_tab' | 'same_tab' | 'popup';
      }) => void;
      closePopupWidget: () => void;
    };
    gtag_report_conversion: (url?: string) => void;
  }
}

interface CalendlyBadgeProps {
  url: string;
  color?: string;
  textColor?: string;
  openUrl?: 'new_tab' | 'same_tab';
  onTrigger?: () => void;
}

export default function CalendlyBadge({ url, color = '#0069ff', textColor = '#ffffff', openUrl = 'new_tab' }: CalendlyBadgeProps) {
  return (
    <div className="calendly-container">
      <ClientCalendly 
        url={url} 
        color={color} 
        textColor={textColor} 
        openUrl={openUrl} 
      />
    </div>
  );
}
